import { inject, Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

import { ListResponse } from '@models/helpers';
import { SearchModel, SearchRequestModel } from '@models/search';
import { HttpService } from '@shared/services';

@Injectable({
  providedIn: 'root',
})
export class SearchService {
  http = inject(HttpService);

  search(searchModel: Partial<SearchRequestModel>): Observable<ListResponse<SearchModel>> {
    if (!searchModel || !searchModel.searchText || !searchModel.searchFilter.userId) return of();

    return this.http.post<ListResponse<SearchModel>>('_api/search-ai', searchModel, { useLoader: false });
  }
}
